// IE 2026 11 02 / ODOO-349799 (sticky-group) (замечание Игоря по dev02, «Конфігурація», группы «Вид, Підсистема»): липкая полоса группы
// показывала заголовок «Підсистеми» над строкой 1, которая и так видна целиком — полоса имеет смысл, только когда строка группы
// ушла за верхний край видимой области. Чистая часть решения — здесь; сбор цепочки групп — AttrGrid.set_stickyRows_afterTimeout.
// Выключатель fe.ux.gridStickyGroupOnlyScrolled (дефолт ВКЛ, §8); ВЫКЛ — прежнее поведение (полоса и при видимой строке группы).

export const STICKY_GROUP_SCROLLED_FLAG = 'fe.ux.gridStickyGroupOnlyScrolled'

// чтение флага (нет читателя / ошибка — ВКЛ)
export function stickyGroupScrolled_on(setting) {
    try { return typeof setting === 'function' ? setting(STICKY_GROUP_SCROLLED_FLAG, true) !== false : true } catch (e) { return true }
}

// Показывать ли полосу для строки группы одного уровня: её верх (top, px в координатах панели строк) выше верхнего края
// видимой области (scrollTop = −scrollPosition.y, px); закреплённая строка (frozen) не прокручивается — полоса не нужна.
// Неизвестный top (строка не измерена) — полоса показывается, как прежде.
export function stickyGroup_rowScrolledOut({ top, scrollTop, frozen } = {}) {
    if (frozen) return false
    if (!Number.isFinite(top)) return true
    const st = Number.isFinite(scrollTop) ? scrollTop : 0
    return top < st
}

// Цепочка уровней (предки сверху вниз: [{ row, top, frozen }, …]) → строки тех уровней, чьи строки-заголовки скрыты прокруткой.
// Предок всегда выше потомка, поэтому результат — префикс цепочки: как только уровень виден, глубже не смотрим.
export function stickyGroup_scrolledChain(chain, scrollTop) {
    const out = []
    for (const it of Array.isArray(chain) ? chain : []) {
        if (!it || !stickyGroup_rowScrolledOut({ top: it.top, scrollTop, frozen: it.frozen })) break
        out.push(it.row)
    }
    return out
}
